module.exports = __webpack_public_path__ + "static/media/ELS.a466f311.png";